import { Container, Row } from "reactstrap";
import { EditProfileTitle, Users } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import MyProfile from "./myProfile";
import EditProfileForm from "./editProfiles";
import Projects from "./projects";

const EditProfileContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={EditProfileTitle} parent={Users} />
      <Container fluid>
        <div className="edit-profile">
          <Row>
            <MyProfile />
            <EditProfileForm />
            <Projects />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default EditProfileContainer;
